import { Profile } from '@app/user/components/Profile';

export const ProfilePage = () => {
  return <Profile />;
};
